export const module_config = {
  SIGN_RECORD_IMPORT_TEMPLATE: {
    name: '签约信息导入模板',
    fields: {
      '红人昵称': 'nickname',
      '签约年': 'asia_sign_date__year',
      '签约月': 'asia_sign_date__month',
      '签约日': 'asia_sign_date__day',
      '签约类型': 'sign_type',
      '签约前平台': 'asia_sign_bef_info_platform_name',
      '签约前粉丝数（个）': 'asia_sign_bef_info_fans_total',
      '签约后主平台': 'platform_name_aft',
      '合约年限（年）': 'term',
      '签约人': 'signatory',
      '红人姓名': 'real_name',
      '身份证号': 'id_card',
      '分配组别（用#分割）': 'asia_group',
      '联系方式': 'tel'
    },
    sourceData: [
      {
        nickname: '示例红人昵称A',
        asia_sign_date__year: '2023',
        asia_sign_date__month: '5',
        asia_sign_date__day: '10',
        term: '3',
        sign_type: '3C数码坐班',
        asia_sign_bef_info_platform_name: '抖音',
        asia_sign_bef_info_fans_total: 65000,
        signatory: '签约人A',
        real_name: '红人姓名A',
        id_card: '身份证号A',
        platform_name_aft: '视频号',
        asia_group: 'MCN第二中心#项目四部#项目4—7组',
        tel: '15000000000'
      }
    ]
  }
}
